import { render, staticRenderFns } from "./LessonChoose.vue?vue&type=template&id=1f3a9098&scoped=true"
import script from "./LessonChoose.vue?vue&type=script&lang=js"
export * from "./LessonChoose.vue?vue&type=script&lang=js"
import style0 from "./LessonChoose.vue?vue&type=style&index=0&id=1f3a9098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3a9098",
  null
  
)

export default component.exports